import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// import {
//   TABLE_DATA,
//   TABLE_HEADERS,
//   keyMapping,
//   topDataList,
// } from "../../../../constants/SalesQuotationApprovalList";

import ROUTES_NAVIGATION from "../../../../routes/routes";
import ListPage from "../../Sales/Shared/ListPage";
import eyeIcon from "../../../../Assets/icons/eye 1.svg";
import editIcon from "../../../../Assets/icons/Un-Checkbox.svg";
import axiosInstance from "../../../services/api/API";
import Loader from "../../../customComponents/CustomLoader";

const POApproval = () => {
  const navigate = useNavigate();

  const [ poApproval, setPoApproval ] = useState([])
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPO,setTotalPO] = useState(0)
  const [loading, setLoading] = useState(true);
  const [pendingPO,setPendingPO] = useState(0)
  const [approvedPO,setApprovedPO] = useState(0)
  const [acceptedPO,setAcceptedPO] = useState(0)
  const [searchQuery, setSearchQuery] = useState('');
  const token = localStorage.getItem("authToken");

  const handleAddNavigation = () => {
    navigate(ROUTES_NAVIGATION.ADDPURCHASEORDER)
  }
  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleViewDetails = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.POAPPROVALDETAILS}`, { state: { data: rowData } });
  }

  const topDataList = [
    { id: 1, title: "Total Purchase Orders", value: totalPO },
    { id: 2, title: "Pending  Purchase Orders", value: pendingPO },
    { id: 3, title: "Approved  Purchase Orders", value: approvedPO },
    { id: 3, title: "Accepted  Purchase Orders", value: acceptedPO },
   
  ];

  const TABLE_HEADERS = [
    "Po No.",
    "Date",
    "Po Type",
    "Vendor Name",
    "Ref. No.",
    "Department",
    "Payment Term",
    "Showroom Center",
    "Total Amount",
    "Action"
  ];

  const keyMapping = {
    "Po No.":"po_number",
    "Date":"po_date",
    "Po Type":"po_type",
    "Vendor Name":"companyname",
    "Ref. No.":"reference_no",
    "Department":"department_name",
    "Payment Term":"payment_term_name",
    "Showroom Center":"showroom_name",
    "Total Amount":"total",
    "Action":[
        // { type: "edit", icon: editIcon, label: "Edit" },
        { type: "view", icon: eyeIcon, label: "View" },
    ],
  };

  useEffect(() => {
    fetchPhysicalStockTakingList()
  },[])
  const apiCallFunction = () =>{
    fetchPhysicalStockTakingList()
  }

  const fetchPhysicalStockTakingList = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true)
      const response = await axiosInstance.post('/purchaseorderapproval/list', {
        orderBy:"po_id desc",
        page,
        pageSize
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });

      const formattedData = response?.data?.data?.data
      const totalRecordsData = response?.data?.data?.totalRecords
      setTotalRecords(totalRecordsData);
      setTotalPO(response?.data?.data?.total_po)
      setPendingPO(response?.data?.data?.total_pending)
      setAcceptedPO(response?.data?.data?.accepted_po)
      setApprovedPO(response?.data?.data?.approved_po)

      setPoApproval(formattedData); 
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize)); 
     
    } catch (error) {
      console.error('Error fetching product list:', error);
    }
    finally{
      setLoading(false)
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchPhysicalStockTakingList(newPage);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      apiCallFunction(0, 10,searchQuery); 
    }
  }
  return (
    <div>
    {loading ? ( 
      <Loader />
    ) : (
      <div>
    <ListPage
    // isButtonRequired={false}
      isButtonRequired={false}
    addButtonTitle = "Create New Order"
    isUploadButtonRequired={false}
      headerTopText="Order / Po Approval"
      headerTitle="PO Approval"
      listTitle="PO Approval List"
      topDetailsList={topDataList}
      tableData={poApproval}
      tableHeaders={TABLE_HEADERS}
      keyMapping={keyMapping}
      handleOnAddButton={handleAddNavigation}
      handleViewButton={handleViewDetails}
      handlePageChange={handlePageChange}
      totalRecords={totalRecords} 
      handleSearchChange={handleSearchChange}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      handleKeyPress={handleKeyPress} 
      apiCallFunction={apiCallFunction}
      currentPage={currentPage}
      totalPages={totalPages}
      searchplaceholder="Search by PO Type"
    />
      </div>
    )}
    </div>
  );
};

export default POApproval;
